import type { ChannelPerformanceStats } from './types';

export const emptyAccumulatorByChannel: ChannelPerformanceStats = {
  Recipients: 0,
  Delivered: 0,
  Opened: 0,
  ClickedLink: 0,
  Unsubscribes: 0,
  FailedDeliveries: 0,
  CampaignDay: 0,
  AllRevenueAttribution: { Carts: 0, Customers: 0, Orders: 0, TotalRevenue: 0 },
  DirectAttribution: { Carts: 0, Customers: 0, Orders: 0, TotalRevenue: 0 },
  OpenersInStoreAttribution: { Carts: 0, Customers: 0, Orders: 0, TotalRevenue: 0 },
  OpenersOnlineAttribution: { Carts: 0, Customers: 0, Orders: 0, TotalRevenue: 0 },
};

export const dayBreakpoints = [1, 3, 5, 7, 15, 30];

export const monthBreakpoints = [1, 2, 3];
